import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";
import { createEventError, ProjectElementType } from "@planzone/dto";

function hasName(name: string): boolean {
  return name.length > 0;
}

function createInteractor(repository: Repository): Interactor {
  return ({ list, event, account, project, range }) =>
    present(
      repository.getUserHumanResource(account).then((resource) =>
        repository
          .saveEvent(project, list, { ...event, organizer: resource })
          .then((savedEvent) =>
            (range
              ? repository.moveProjectElement(
                  savedEvent.uuid,
                  ProjectElementType.EVENT,
                  list,
                  range,
                  false,
                )
              : Promise.resolve()
            ).then(() => ({
              project,
              list,
              account,
              event: savedEvent,
              range,
            })),
          )
          .catch((error) =>
            Promise.reject({
              project,
              account,
              list,
              event,
              range,
              error: {
                ...createEventError,
                ...error,
                emptyName: !hasName(event.name),
              },
            }),
          ),
      ),
    );
}

export type { Interactor };

export { createInteractor };
